import AzureAiClientBase from "./ai.base.client";

export class ValidateIntent extends AzureAiClientBase {
    public async handleValidateIntent(query: string) {
        const prompt = `You are an intent classifier. Your role is to classify the user's query intent for routing.
            You are an intent classifier. Your role is to classify the user's query intent for routing.
            Return a JSON object like this: {"response": "search"} or {"response": "assistant"}

            Rules:
            1. If the user's query is about an IT or technical issue (e.g., password reset, device not working, login problem), return: {"response": "assistant"}

            2. If the query is a **question or a request** — that is, the user is asking for information or help, regardless of language or phrasing — return: {"response": "assistant"}

                This includes:
                - Questions that start with words like who, what, where, how, why, which, etc.
                - Requests that begin with phrases like “Can you...”, “Would you...”, “Please send...”, “I need...”, etc.
                - Any phrasing that clearly seeks an answer or assistance.

            3. Otherwise, return: {"response": "search"}

            User's query: ${query}
        `

        try {
            const outputMessages = await this.sendRequest([
                {
                    role: "system",
                    content: prompt,
                }
            ], {
                response_format: {
                    type: "json_object"
                }
            });

            return {
                output: JSON.parse(outputMessages[0].content).response,
                source: '',
                action: "validate_intent",
            };
        } catch (error) {
            console.error("Error validating intent:", error);
            return {
                output: "search",
                source: '',
                action: "validate_intent",
            }
        }

    }
}

export default ValidateIntent;
